var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-4",attrs:{"fluid":""}},[_c('b-table-simple',_vm._l((_vm.orderItems),function(ref){
var logicode = ref.logicode;
var img = ref.img;
var cnt = ref.cnt;
var title = ref.title;
var status = ref.status;
return _c('b-tr',{class:{ 'text-through': status === 5 }},[_c('b-td',[_vm._v("\n        "+_vm._s(logicode)+"\n      ")]),_c('b-td',{staticClass:"text-center"},[_c('b-img',{attrs:{"width":"100","height":"100","src":img}}),_c('div',{class:{ 'text-danger': cnt > 1 }},[_vm._v("x "+_vm._s(cnt))])],1),_c('b-td',[_vm._v("\n        "+_vm._s(title)+"\n      ")]),_c('b-td',[_vm._v("\n        "+_vm._s(status)+"\n      ")])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }